import { createClient } from '@sanity/client';
import imageUrlBuilder from '@sanity/image-url';

export const client = createClient({
  projectId: 'kxxtoumf',
  // "dev" is the permanent/production dataset — all content lives here now. The separate
  // "production" dataset in Sanity still exists but is unused and will be deleted later.
  dataset: 'dev',
  apiVersion: '2025-05-12',
  useCdn: true,
  perspective: 'raw',
});

// Get a pre-configured url-builder from your sanity client
const builder = imageUrlBuilder(client);

// Serves resized, modern-format (WebP/AVIF) images from Sanity's CDN instead of
// the original upload — pass `width` to cap the requested size for the image's
// actual rendered role (hero vs. carousel vs. thumbnail). SVGs (no width passed)
// pass through unaffected since there's no raster format to negotiate.
//
// `width` is a CSS-pixel target, so it's scaled up by devicePixelRatio (capped
// at 2x — the visual gain beyond that is negligible against the extra download
// size) to request enough source pixels for retina/high-DPI screens to render
// sharp instead of upscaling a 1x image. Quality drops when we do this: the
// extra pixel density more than makes up for it perceptually, and it keeps
// the ~4x-pixel-count file from taking noticeably longer to load than the 1x
// version did (which sections gated on the image loading, like the hero
// title reveal, were visibly waiting on).
export const urlFor = (source, { width } = {}) => {
  if (!source) return null;
  let img = builder.image(source).auto('format');
  if (width) {
    const dpr = Math.min(window.devicePixelRatio || 1, 2);
    img = img.width(Math.round(width * dpr)).quality(dpr > 1 ? 60 : 80);
  } else {
    img = img.quality(80);
  }
  return img.url();
};
